import { render, staticRenderFns } from "./ClassroomTypeForm.vue?vue&type=template&id=17700e2b"
import script from "./ClassroomTypeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomTypeForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports